import Link from "@/src/common/components/Link"
import React, { ReactNode } from "react"

const colorMapper = {
  black: "text-stears_black",
  white: "text-stears_white",
  blue: "text-accent-600"
}
type SimpleLinkProps = {
  color?: keyof typeof colorMapper
  href: string
  children: ReactNode
  onClick?: () => void
}

export const SimpleLink = (props: SimpleLinkProps) => {
  const colorCss = colorMapper[props.color || "black"]
  return (
    <Link
      href={props.href}
      className={`text-btn_15 hover:underline ${colorCss}`}
      onClick={props.onClick}
    >
      {props.children}
    </Link>
  )
}
